import React from 'react';


export default function Range(props) {
  const [value, setValue] = React.useState(props.min);
  const onChange = event => {
    const value = event.target.value;
    setValue(value);
    if (props.onChange) props.onChange(value);
  };

  const { label, min, max, step, unit } = props;
  return (
      <p><strong>{label}</strong>:
        <input type="range" min={min} max={max} step={step}
               value={value} onChange={onChange}/>
        {value}
        {unit}
      </p>
  );
}

Range.defaultProps = {
  label: 'Value',
  min: 0,
  max: 100,
  step: 1,
  unit: ''
};

/*
class Range extends React.Component {
  constructor(props) {
    super(props);
    this.state = { value: props.min };
    this.onChange = this.onChange.bind(this);
  }

  onChange(event) {
    const value = event.target.value;
    this.setState({value});
    if (this.props.onChange) this.props.onChange(value);
  }

  render() {
    const { label, min, max, step, unit } = this.props;
    return (
      <p><strong>{label}</strong>:
        <input type="range" min={min} max={max} step={step}
               value={this.state.value} onChange={this.onChange}/>
        {this.state.value}
        {unit}
      </p>
    );
  }

}

export default Range;
*/
